import firebase from 'firebase'
import "firebase/auth"
import "firebase/database"
import "firebase/storage"


var firebaseConfig = {
    apiKey: "AIzaSyAWRiN8uVV8Oi6xA7vNIPiAhu9L9XQaoec",
    authDomain: "slack-clone-6b3c1.firebaseapp.com",
    databaseURL: "https://slack-clone-6b3c1.firebaseio.com",
    projectId: "slack-clone-6b3c1",
    storageBucket: "slack-clone-6b3c1.appspot.com",
    messagingSenderId: "588826656802",
    appId: "1:588826656802:web:357d4b95635f854e64ca7b",
    measurementId: "G-QCQYRB9V9E"
};

firebase.initializeApp(firebaseConfig)

export default firebase